// Permission enums based on ${RESOURCE}_${ACTION}_${SCOPE} format
export enum Permission {
  ORDER_CREATE_GLOBAL = 'order:create:global',
  ORDER_CREATE_CUSTOMER = 'order:create:customer',
  ORDER_VIEW_GLOBAL = 'order:view:global',
  ORDER_VIEW_CUSTOMER = 'order:view:customer',
  INVOICE_VIEW_GLOBAL = 'invoice:view:global',
  INVOICE_VIEW_CUSTOMER = 'invoice:view:customer',
  USER_CREATE_GLOBAL = 'user:create:global',
  USER_CREATE_CUSTOMER = 'user:create:customer',
  USER_VIEW_GLOBAL = 'user:view:global',
  USER_VIEW_CUSTOMER = 'user:view:customer',
  USER_UPDATE_GLOBAL = 'user:update:global',
  USER_UPDATE_CUSTOMER = 'user:update:customer',
  USER_DELETE_GLOBAL = 'user:delete:global',
  USER_DELETE_CUSTOMER = 'user:delete:customer',
  PAYMENT_METHOD_CREATE_OWN = 'payment_method:create:own',
  PAYMENT_METHOD_VIEW_OWN = 'payment_method:view:own',
  ORDER_UPDATE_GLOBAL = 'order:update:global',
  ORDER_UPDATE_CUSTOMER = 'order:update:customer',
  ORDER_UPDATE_OWN = 'order:update:own',
  CUSTOMER_VIEW_GLOBAL = 'customer:view:global',
  CUSTOMER_VIEW_OWN = 'customer:view:own',
  DASHBOARD_VIEW_GLOBAL = 'dashboard:view:global',
  DASHBOARD_VIEW_CUSTOMER = 'dashboard:view:customer',
}
